import React, { useState } from 'react';
import { connect } from 'react-redux';
import { removeUser } from '../../actions/reduxActions/organizations';
import Confirm from '../generic/confirm';
import translations from '../../translations';

export const LeaveOrg = ({ currentUser, leaveUserOrganization }) => {
    const [leaveConfirmationVisible, setLeaveConfirmationVisible] = useState(false);

    const showLeaveConfirmation = () => setLeaveConfirmationVisible(true);
    const hideLeaveConfirmation = () => setLeaveConfirmationVisible(false);

    return (
        <>
            <button 
                className="btn btn-danger" 
                onClick={showLeaveConfirmation}
            >
                Leave this organization
            </button>
            <Confirm 
                show={leaveConfirmationVisible}
                onCancel={hideLeaveConfirmation}
                onConfirm={() => {
                    leaveUserOrganization({ 
                        userId: currentUser.id, 
                        email: currentUser.email,
                    });
                    hideLeaveConfirmation();
                }}
                title={translations.FORG_leave_confirmation_title}
                messages={[translations.FORG_leave_confirmation]}
            />
        </>
    );
};

const mapStateToProps = state => ({
    currentUser: state.currentUser,
});

const mapDispatchToProps = {
    leaveUserOrganization: removeUser,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LeaveOrg);
